<ng-container *ngIf="formFactoryField$ | async as formFactoryFieldRef">
    <mat-checkbox [formControl]="formFactoryFieldRef.formControl">{{ formFactoryFieldRef.label }}</mat-checkbox>
</ng-container>
